import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdDialpad } from 'react-icons/md';

const Dialpad: React.FC<IconBaseProps> = (props) => <MdDialpad {...props} />;

export default Dialpad;
